import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { useApiClient } from '../context';
import type { FamilySummary, FamilyResponse } from '../types';

export function useFamilies() {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['families'],
    queryFn: () => apiClient.get<{ families: FamilySummary[] }>('/api/families'),
  });
}

export function useCreateFamily() {
  const apiClient = useApiClient();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (familyName: string) =>
      apiClient.post<{ family: FamilySummary }>('/api/families', { name: familyName }),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['families'] });
    },
  });
}

export function useFamily(familyId: string | undefined) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['family', familyId],
    queryFn: () => apiClient.get<FamilyResponse>(`/api/families/${familyId}`),
    enabled: !!familyId,
  });
}
